var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Left - Rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90588 14.1501C9.46303 13.7001 9.31541 13.0251 9.75826 12.5001L10.9392 10.9251L4.51779 10.9251C3.8535 10.9251 3.41064 10.4001 3.41064 9.8001L3.41065 9.0501C3.41065 8.3751 3.92731 7.9251 4.51779 7.9251L10.9392 7.9251L9.75826 6.3501C9.38922 5.8251 9.46303 5.0751 9.97969 4.7001L10.5702 4.2501C11.0868 3.8751 11.7511 3.9501 12.194 4.4751L15.294 8.5251C15.7368 9.0501 15.7368 9.8001 15.294 10.4001L12.1202 14.3751C11.7511 14.9001 11.013 14.9751 10.4964 14.6001L9.90588 14.1501Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRounded);
export default __webpack_public_path__ + "static/media/arrowLeftRounded.4a9744d9e4b155a53e0c0f435382b3ff.svg";
export { ForwardRef as ReactComponent };